import React from 'react'

const GlobalModal = ({
  isOpen,
  title,
  children,
  onClose,
  showConfirm = true,
  confirmText = 'Confirm',
  onConfirm,
  showCancel = true,
  cancelText = 'Cancel',
  onCancel,
  showProBadge = false,
  isUpgradeModal = false,
  confirmDisabled = false,
}) => {
  if (!isOpen) return null

  return (
    <div className='modal-overlay' onClick={onClose}>
      <div className='modal-container' onClick={(e) => e.stopPropagation()}>
        <div className='modal-header'>
          <h3 className='modal-title'>
            {isUpgradeModal && <span className='pro-badge'>PRO</span>}
            {title}
          </h3>
          <button className='modal-close' onClick={onClose}>
            ×
          </button>
        </div>

        <div className='modal-body'>{children}</div>

        <div className='modal-footer'>
          {showCancel && (
            <button className='modal-button modal-button-secondary' onClick={onCancel}>
              {cancelText}
            </button>
          )}
          {showConfirm && (
            <button
              className={`modal-button modal-button-primary ${isUpgradeModal ? 'upgrade-button' : ''}`}
              onClick={onConfirm}
              disabled={confirmDisabled}
            >
              {confirmText}
              {isUpgradeModal && <span className='pro-badge-inline'>PRO</span>}
            </button>
          )}
        </div>
      </div>
    </div>
  )
}

export default GlobalModal
